import { ALERT_CONFIG } from "../constants";
import Swal from "sweetalert2";
import i18n from "../../configs/i18n";
import size from "lodash/size";

Swal.mixin({
    // Set default options for SweetAlert
    confirmButtonColor: "#3B7D36",
    cancelButtonColor : "#d33",
    reverseButtons    : true
});

export const toastify = ({
    title,
    type = "success",
    desc = ""
}) => {
    return Swal.fire({
        toast            : true,
        position         : "top-end",
        showConfirmButton: false,
        timer            : 3000,
        timerProgressBar : true,
        showCloseButton  : true,
        didOpen          : toast => {
            toast.addEventListener("mouseenter", Swal.stopTimer);
            toast.addEventListener("mouseleave", Swal.resumeTimer);
        },
        icon : type,
        title: i18n.t(title),
        ...(size(desc) && { text: i18n.t(desc) })
    });
};

export const confirmAlert = (options) => {
    const showCancelButton = options.showCancelButton === undefined;
    const customOptions = !options.action ? (options = {
        ...options,
        text:
          i18n.t(options.text || "") ||
          i18n.t("Do you really want to proceed?"),
        confirmButtonText:
          i18n.t(options.confirmButtonText || "") || i18n.t("Confirm"),
        cancelButtonText:
          i18n.t(options.cancelButtonText || "") || i18n.t("Cancel"),
        showCancelButton,
        allowOutsideClick  : options.allowOutsideClick,
        showLoaderOnConfirm: !!options.preConfirm,
        preConfirm         : options.preConfirm,
        title              : i18n.t(options.title || ""),
        preDeny            : options.preDeny
    }) : {
        ...ALERT_CONFIG[options.action],
        title: i18n.t(
            options.title || ALERT_CONFIG[options.action].title || ""
        ),
        text:
      i18n.t(options.text || ALERT_CONFIG[options.action].text) ||
      i18n.t("Do you really want to proceed?"),
        confirmButtonText:
      i18n.t(ALERT_CONFIG[options.action].confirmButtonText) ||
      i18n.t("Confirm"),
        cancelButtonText:
          i18n.t(ALERT_CONFIG[options.action].cancelButtonText || "") ||
          i18n.t("Cancel"),
        allowOutsideClick  : options.allowOutsideClick || false,
        showLoaderOnConfirm: !!options.preConfirm,
        preConfirm         : options.preConfirm,
        preDeny            : options.preDeny
    };
    return Swal.fire(customOptions);
};
